exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  overflow-x: hidden;\n}\n\n.scoll-container {\n  position: relative;\n  display: flex;\n  transition: .4s;\n}\n\n.item:last-child {\n  margin-right: 0 !important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/viega-common/components/item-scrollbox/item-scrollbox.component.scss
// module id = 5sAC
// module chunks = 5